// extracted by mini-css-extract-plugin
export default {"zoomModal":"A3-z","image":"B3-z","button":"C3-z","isOverlayShown":"D3-z"};